/** Stable identity for a staged file, used for de-duplication and React keys. */
export const fileKey = (file: File): string =>
    `${file.name}-${file.size}-${file.lastModified}`;
